<template>
  <a-layout
    :class="{
      settings__borderLess: settings.isBorderless,
      settings__squaredBorders: settings.isSquaredBorders,
      settings__fixedWidth: settings.isFixedWidth,
      settings__menuShadow: settings.isMenuShadow,
      settings__menuTop: settings.isMenuTop
    }"
  >
    <!-- left menu -->
    <a-layout-header>
      <cui-topbar @showLoader="showLoader" :settings="settings" />
    </a-layout-header>

    <cui-settings :settings="settings" />
    <!-- left menu mobile -->
    <div v-if="settings.isMobileView">
      <div :class="$style.handler" @click="toggleMobileMenu">
        <div :class="$style.handlerIcon"></div>
      </div>
      <a-drawer
        :closable="false"
        :visible="settings.isMobileMenuOpen"
        placement="left"
        :wrapClassName="$style.mobileMenu"
        @close="toggleMobileMenu"
      >
        <cui-menu-left :settings="settings" />
      </a-drawer>
    </div>
    <a-layout>
      <a-layout-content>
        <div :class="$style.main_content">
          <a-spin
            tip="Youre logged out please wait..."
            :spinning="loading"
            size="large"
          >
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 30px"
              spin
            />
            <router-view />
          </a-spin>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapState } from 'vuex'
import CuiTopbar from '@/components/LayoutComponents/Topbar'
import CuiSettings from '@/components/LayoutComponents/Settings'
import CuiMenuLeft from '@/components/LayoutComponents/Menu/MenuLeft'

export default {
  name: 'MainLayout',
  components: { CuiTopbar, CuiMenuLeft, CuiSettings },
  computed: mapState(['settings']),
  data() {
    return {
      loading: false,
      version: undefined,
    }
  },
  mounted() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.version = settings.application.buildVersion
    this.detectViewPort(true)
    window.addEventListener('resize', this.detectViewPortListener)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectViewPortListener)
  },
  methods: {
    toggleMobileMenu() {
      const value = !this.settings['isMobileMenuOpen']
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMobileMenuOpen',
        value,
      })
    },
    onCollapse: function(collapsed, type) {
      const value = !this.settings['isMenuCollapsed']
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMenuCollapsed',
        value,
      })
    },
    changeSetting: function(setting, value) {
      this.$store.commit('CHANGE_SETTING', { setting, value })
    },
    setViewPort: function(isMobileView = false, isTabletView = false) {
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMobileView',
        value: isMobileView,
      })
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isTabletView',
        value: isTabletView,
      })
    },
    detectViewPortListener: function() {
      this.detectViewPort(false)
    },
    detectViewPort: function(firstLoad = false) {
      const isMobile = this.settings['isMobileView']
      const isTablet = this.settings['isTabletView']
      const width = window.innerWidth
      const state = {
        next: {
          mobile: width < 768,
          tablet: width < 992,
          desktop: !(width < 768) && !(width < 992),
        },
        prev: {
          mobile: isMobile,
          tablet: isTablet,
          desktop: !isMobile && !isTablet,
        },
      }
      // desktop
      if (
        state.next.desktop &&
        (state.next.desktop !== state.prev.desktop || firstLoad)
      ) {
        this.setViewPort(false, false)
      }
      // tablet & collapse menu
      if (
        state.next.tablet &&
        !state.next.mobile &&
        (state.next.tablet !== state.prev.tablet || firstLoad)
      ) {
        this.setViewPort(false, true)
        this.$store.commit('CHANGE_SETTING', {
          setting: 'isMenuCollapsed',
          value: true,
        })
      }
      // mobile
      if (
        state.next.mobile &&
        (state.next.mobile !== state.prev.mobile || firstLoad)
      ) {
        this.setViewPort(true, false)
      }
    },
    showLoader(flag) {
      this.loading = flag
    },
    redirectTo() {
      if (this.$router.currentRoute.path !== '/releaseNotes') {
        this.$router.push('/releaseNotes')
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
